import React, { PropsWithChildren, ReactNode, useState } from 'react';
import { DrawerProps as MuiDrawerProps } from '@mui/material';
import {
  BottomSheetBody,
  BottomSheetHeader,
  BottomSheetInner,
  Drawer,
} from '@/components/@IntranetLibrary/PcBottomSheet/styles';
import HeaderButtonBox, {
  HeaderButtonBoxProps,
} from '@/components/@IntranetLibrary/Modal/HeaderButtonBox';
import useScrollLock from '@/hooks/useScrollLock';
import classNames from 'classnames';

export type PcBottomSheetProps = PropsWithChildren<
  {
    title?: string;
    readonly isOpen: MuiDrawerProps['open'];
    readonly handleClose: () => void;
    additionalButton?: ReactNode;
  } & Pick<HeaderButtonBoxProps, 'isExpandable'>
>;

const PcBottomSheet: React.FC<PcBottomSheetProps> = ({
  title,
  isExpandable = true,
  additionalButton,
  isOpen,
  handleClose,
  children,
}) => {
  const [isExpand, setIsExpand] = useState(false);

  useScrollLock(Boolean(isOpen));

  const handleClickExpandButton = () => {
    setIsExpand(!isExpand);
  };

  return (
    <Drawer
      open={isOpen}
      onClose={handleClose}
      anchor={'bottom'}
      className={classNames({ expand: isExpand })}
    >
      <BottomSheetInner>
        <BottomSheetHeader>
          <h1>{title}</h1>
          <HeaderButtonBox
            isExpandable={isExpandable}
            isExpand={isExpand}
            handleClickExpandButton={handleClickExpandButton}
            handleClickCloseButton={handleClose}
          >
            {additionalButton}
          </HeaderButtonBox>
        </BottomSheetHeader>
        <BottomSheetBody className={'bottom-sheet-body'}>
          {children}
        </BottomSheetBody>
      </BottomSheetInner>
    </Drawer>
  );
};

export default PcBottomSheet;
